module.exports = __webpack_public_path__ + "media/lobby_selfintro.b67de775.mp3";